export const API = {
  PRODUCT: process.env.REACT_APP_PRODUCT_API,
  USER: process.env.REACT_APP_USER_API,
  IMAGE: process.env.REACT_APP_IMAGE_API,
  BLOG: process.env.REACT_APP_BLOG_API,
  NEWS: process.env.REACT_APP_NEWS_API,
  ORDER: process.env.REACT_APP_ORDER_API,
};